import moment from 'moment';
import { BaseQuery2 } from '@/utils';
import { CALCWEIGHT, PIECE } from '@/models/GenerateCondit/Interrelated';

let planBase = 'route_plan_result'
let actualBase = 'actual_load_unload_result '

export function baseChange(type) {
  if (type === 0) {
    planBase = 'route_plan_result'
    actualBase = 'actual_load_unload_result'
  } else {
    planBase = 'route_plan_waybill_day_result'
    actualBase = 'actual_load_unload_waybill_day_result'
  }
}

const getCurrentSystemTime = (params) => {
  if (!params.currentStartTime || !params.currentEndTime) {
    return null;
  }
  if (planBase !== 'route_plan_result') {
    return null
  }
  const currentSystemTime = {
    "dimension": "currentSystemTime",
    "lowerValue": moment(params.currentStartTime).format("YYYY-MM-DD HH:mm:ss"),
    "upperValue": moment(params.currentEndTime).format("YYYY-MM-DD HH:mm:ss"),
    "lowerEq": false,
    "upperEq": false
  }
  return currentSystemTime
}

/** 获取流向基准*/
export const PlanDepartureBasise = params => {
  return {
    simpleGranularity: 'all',
    dataSource: planBase,
    dimensions: ['nextProvinceArea', 'scanSite', 'nextSite', 'taskNo'], //taskNo 无用
    startDate: params.startDate,
    endDate: params.endDate,
    aggregators: [CALCWEIGHT],      // 聚合无用
    andFilters: [
      { key: 'scanType', value: '分拨发车' },
      { key: 'isDestinationCenter', value: '否' },
    ],
    inFilters: [
      { key: 'scanSite', value: params.scanSite },
    ]
  }
}

/** 根据省区获取下一站 */
export const PlanProvenceGetNext = params => {
  return {
    simpleGranularity: 'all',
    dataSource: planBase,
    dimensions: ['scanSite'],
    startDate: params.startDate,
    endDate: params.endDate,
    // aggregators: [CALCWEIGHT],
    andFilters: [
      { key: 'scanType', value: '分拨发车' },
      { key: 'isDestinationCenter', value: '否' },
      { key: 'scanProvinceArea', value: params.scanProvinceArea },
    ]
  }
}

/**
 * 网名/中转/在库列表
*/
export const PlanDepartureNextSiteQuery = params => {
  const currentSystemTime = getCurrentSystemTime(params)
  const bound = []
  if (currentSystemTime) {
    bound.push(currentSystemTime)
  }
  return [
    {
      // 网点到达预计 0
      simpleGranularity: 'all',
      dataSource: planBase,
      dimensions: ['nextSite', 'scanSite'],
      startDate: params.startDate,
      endDate: params.endDate,
      aggregators: [CALCWEIGHT],
      andFilters: [
        { key: 'scanType', value: '分拨到车' },
        { key: 'isOriginCenter', value: '是' },
        { key: 'isDestinationCenter', value: '否' },
      ],
      inFilters: [
        { key: 'scanSite', value: params.scanSite },
        { key: 'nextSite', value: params.nextSites },
      ],
    },
    {
      // 网点到达实际 1
      simpleGranularity: 'all',
      dataSource: actualBase,
      dimensions: ['nextSite', 'scanSite'],
      startDate: moment(params.startDate).add(0, 'day').format('YYYY-MM-DD HH:mm:ss'),
      // startDate: params.startDate,
      endDate: params.endDate,
      aggregators: [CALCWEIGHT],
      andFilters: [
        { key: 'scanType', value: '分拨卸车' },
        { key: 'isOriginCenter', value: '是' },
        { key: 'isDestinationCenter', value: '否' },
      ],
      inFilters: [
        { key: 'scanSite', value: params.scanSite },
        { key: 'nextSite', value: params.nextSites },
      ],
    },
    {
      // 中转到达预计 2
      simpleGranularity: 'all',
      dataSource: planBase,
      dimensions: ['nextSite', 'scanSite'],
      startDate: params.startDate,
      endDate: params.endDate,
      aggregators: [CALCWEIGHT],
      andFilters: [
        { key: 'isOriginCenter', value: '否' },
        { key: 'isDestinationCenter', value: '否' },
        { key: 'scanType', value: '分拨到车' },
      ],
      inFilters: [
        { key: 'scanSite', value: params.scanSite },
        { key: 'nextSite', value: params.nextSites },
      ],
    },
    {
      // 中转到达实际 3
      simpleGranularity: 'all',
      dataSource: actualBase,
      dimensions: ['nextSite', 'scanSite'],
      startDate: params.startDate,
      endDate: params.endDate,
      aggregators: [CALCWEIGHT],
      andFilters: [
        { key: 'isOriginCenter', value: '否' },
        { key: 'isDestinationCenter', value: '否' },
        { key: 'scanType', value: '分拨卸车' },
      ],
      inFilters: [
        { key: 'scanSite', value: params.scanSite },
        { key: 'nextSite', value: params.nextSites },
      ],
    },
    // #region 在库查询条件
    {
      // 4  分拨卸车
      simpleGranularity: 'all',
      dataSource: actualBase,
      dimensions: ['nextSite', 'scanSite'],
      // startDate: params.startDate, // moment(params.startDate).add(-7, 'days').format('YYYY-MM-DD HH:mm:ss') ,
      startDate: moment(params.startDate).add(-3, 'days').format('YYYY-MM-DD HH:mm:ss'),
      endDate: params.endDate,
      aggregators: [CALCWEIGHT],
      andFilters: [
        { key: 'scanType', value: '分拨卸车' },
        { key: 'isDestinationCenter', value: '否' },
      ],
      boundFilters: [
        ...bound,
      ],
      inFilters: [
        { key: 'scanSite', value: params.scanSite },
        { key: 'nextSite', value: params.nextSites },
      ],
      // unloadTime
    },
    {
      // 5  分拨装车
      simpleGranularity: 'all',
      dataSource: actualBase,
      dimensions: ['planNextSite', 'scanSite'],
      startDate: moment(params.startDate).add(-3, 'days').format('YYYY-MM-DD HH:mm:ss'),
      // startDate: params.startDate,
      endDate: params.endDate,
      aggregators: [CALCWEIGHT],
      andFilters: [
        { key: 'scanType', value: '分拨装车' },
        // { key: 'isDestinationCenter', value: '否' },
      ],
      inFilters: [
        { key: 'scanSite', value: params.scanSite },
        { key: 'planNextSite', value: params.nextSites },
      ],
      boundFilters: [
        ...bound,
        {
          "dimension": "unloadAggregateTime",
          "lowerValue": moment(params.startDate).add(-3, 'days').format('YYYY-MM-DD'),
          "upperValue": moment(params.endDate).format('YYYY-MM-DD'),
          "lowerEq": false,
          "upperEq": false
        }
      ],
    },
    // #endregion

    // #region 在库(7日库存)查询条件
    {
      // 6  分拨卸车
      simpleGranularity: 'all',
      dataSource: actualBase,
      dimensions: ['nextSite', 'scanSite'],
      startDate: moment(params.startDate).add(-7, 'days').format('YYYY-MM-DD HH:mm:ss'),
      endDate: params.endDate,
      aggregators: [CALCWEIGHT],
      andFilters: [
        { key: 'scanType', value: '分拨卸车' },
        { key: 'isDestinationCenter', value: '否' },
      ],
      inFilters: [
        { key: 'scanSite', value: params.scanSite },
        { key: 'nextSite', value: params.nextSites },
      ],
      // unloadTime
    },
    {
      // 7  分拨装车
      simpleGranularity: 'all',
      dataSource: actualBase,
      dimensions: ['planNextSite', 'scanSite'],
      startDate: moment(params.startDate).add(-7, 'days').format('YYYY-MM-DD HH:mm:ss'),
      endDate: params.endDate,
      aggregators: [CALCWEIGHT],
      andFilters: [
        { key: 'scanType', value: '分拨装车' },
      ],
      inFilters: [
        { key: 'scanSite', value: params.scanSite },
        { key: 'planNextSite', value: params.nextSites },
      ],
      boundFilters: [
        {
          "dimension": "unloadAggregateTime",
          "lowerValue": moment(params.startDate).add(-7, 'days').format('YYYY-MM-DD'),
          "upperValue": moment(params.endDate).format('YYYY-MM-DD'),
          "lowerEq": false,
          "upperEq": false
        }
      ],
    },
    // #endregion

  ]
}


/**
 * 按天统计表库存
 * @param {*} params
 * @returns
 */
export const OnewDayStockQuery = (params) => {
  return [
    {
      remark: '按天统计表卸车库存',
      simpleGranularity: 'all',
      dataSource: 'actual_load_unload_waybill_day_result',
      dimensions: ['nextSite', 'scanSite'],
      startDate: moment(params.startDate).add(-3, 'days').format('YYYY-MM-DD 00:00:00'),
      endDate: moment(params.endDate).format('YYYY-MM-DD 00:00:00'),
      aggregators: BaseQuery2(),
      andFilters: [
        { key: 'isDestinationCenter', value: '否' },
        { key: 'scanType', value: '分拨卸车' },
      ],
      inFilters: [
        { key: 'scanSite', value: params.scanSite },
        { key: 'nextSite', value: params.nextSites },
      ],
    },
    {
      remark: '按天统计表装车库存',
      simpleGranularity: 'all',
      dataSource: 'actual_load_unload_waybill_day_result',
      dimensions: ['planNextSite', 'scanSite'],
      startDate: moment(params.startDate).add(-3, 'days').format('YYYY-MM-DD 00:00:00'),
      endDate: moment(params.endDate).format('YYYY-MM-DD 00:00:00'),
      aggregators: BaseQuery2(),
      andFilters: [
        // { key: 'isDestinationCenter', value: '否' },
        { key: 'scanType', value: '分拨装车' },
      ],
      inFilters: [
        { key: 'scanSite', value: params.scanSite },
        { key: 'planNextSite', value: params.nextSites },
      ],
      boundFilters: [
        {
          "dimension": "unloadAggregateTime",
          "lowerValue": moment(params.startDate).add(-3, 'days').format('YYYY-MM-DD'),
          "upperValue": moment(params.endDate).format('YYYY-MM-DD'),
          "lowerEq": false,
          "upperEq": false
        }
      ],
    },
    // #endregion
  ]
}

/**
 * 已装未发
 * 分拨装车(1) - 根据tms已发出车辆任务号查(0)
 * @taskNos 任务号集合
 * @siteTaskNos 当前站发往下一站所有taskNo集合
*/
export const actualDepartureQuery = params => {
  return [
    {
      // 已装未发实际
      remark: '已装未发实际',
      simpleGranularity: 'all',
      dataSource: actualBase,
      dimensions: ['nextSite', 'scanSite'],
      startDate: moment(params.startDate).add(-7, 'days').format('YYYY-MM-DD HH:mm:ss'),
      // startDate: params.startDate,
      endDate: params.endDate,
      aggregators: [CALCWEIGHT],
      andFilters: [
        { key: 'scanType', value: '分拨装车' },
        { key: 'isDestinationCenter', value: '否' },
      ],
      inFilters: [
        { key: 'scanSite', value: params.scanSite },
        { key: 'taskNo', value: params.taskNos },
      ]
    },
    {
      // 已装未发计划
      remark: '已装未发计划',
      simpleGranularity: 'all',
      dataSource: actualBase,
      dimensions: ['nextSite', 'scanSite'],
      startDate: moment(params.startDate).add(-7, 'days').format('YYYY-MM-DD HH:mm:ss'),
      // startDate: params.startDate,
      endDate: params.endDate,
      aggregators: [CALCWEIGHT],
      andFilters: [
        { key: 'scanType', value: '分拨装车' },
        { key: 'isDestinationCenter', value: '否' },
      ],
      inFilters: [
        { key: 'scanSite', value: params.scanSite },
        { key: 'taskNo', value: params.taskNos_plan },
      ]
    },
  ]
}

/**
 * 网点/中转明细
 */
export const PlanWeightDetialQuery = (params) => {
  return {
    plan: {
      // 网点到达预计 0
      simpleGranularity: 'all',
      dataSource: planBase,
      dimensions: ['waybillNo', 'preSite', 'productType'],
      startDate: params.startDate,
      endDate: params.endDate,
      aggregators: BaseQuery2(),
      andFilters: [
        { key: 'scanType', value: '分拨到车' },
        { key: 'isOriginCenter', value: params.isOriginCenter },
        { key: 'isDestinationCenter', value: '否' },
        { key: 'scanSite', value: params.scanSite },
        { key: 'nextSite', value: params.nextSite },
      ],
    },
    actual: {
      // 网点到达实际 1
      simpleGranularity: 'all',
      dataSource: actualBase,
      dimensions: ['waybillNo', 'preSite', 'productType'],
      startDate: params.startDate,
      endDate: params.endDate,
      aggregators: BaseQuery2(),
      andFilters: [
        { key: 'scanType', value: '分拨卸车' },
        { key: 'isOriginCenter', value: params.isOriginCenter },
        { key: 'isDestinationCenter', value: '否' },
        { key: 'scanSite', value: params.scanSite },
        { key: 'nextSite', value: params.nextSite },
      ],
    },
    getPlanPreSite: {
      // 预计到的上一站 1
      simpleGranularity: 'all',
      dataSource: planBase,
      dimensions: ['preSite', 'waybillNo'],
      startDate: params.startDate,
      endDate: params.endDate,
      // aggregators: BaseQuery2(),
      andFilters: [
        { key: 'isOriginCenter', value: params.isOriginCenter },
        { key: 'isDestinationCenter', value: '否' },
        { key: 'scanType', value: '分拨到车' },
        { key: 'scanSite', value: params.scanSite },
        { key: 'nextSite', value: params.nextSite },
      ],
      inFilters: [
        { key: 'waybillNo', value: params.waybillNo }
      ],
    }
  }
}

/**
  库存(装卸)导出明细
 */
export const DesSiteDetailQuery = (params) => {

  const currentSystemTime = getCurrentSystemTime(params)
  const bound = []
  if (currentSystemTime) {
    bound.push(currentSystemTime)
  }
  return {
    unload: {
      // 卸车
      simpleGranularity: 'all',
      dataSource: actualBase,
      dimensions: ['waybillNo', 'productType', 'nextSite', 'destinationCenter'],
      startDate: moment(params.startDate).add(-7, 'days').format('YYYY-MM-DD HH:mm:ss'),
      endDate: params.endDate,
      aggregators: BaseQuery2(),
      andFilters: [
        { key: 'scanType', value: '分拨卸车' },
        { key: 'isDestinationCenter', value: '否' },
        { key: 'scanSite', value: params.scanSite },
        { key: 'nextSite', value: params.nextSite },
      ],
      boundFilters: [
        ...bound
      ],
    },
    load: {
      // 装车
      simpleGranularity: 'all',
      dataSource: actualBase,
      dimensions: ['waybillNo', 'productType', 'planNextSite', 'destinationCenter'],
      startDate: moment(params.startDate).add(-7, 'days').format('YYYY-MM-DD HH:mm:ss'),
      endDate: params.endDate,
      aggregators: BaseQuery2(),
      andFilters: [
        { key: 'scanType', value: '分拨装车' },
        // { key: 'isDestinationCenter', value: '否' },
        { key: 'scanSite', value: params.scanSite },
        { key: 'planNextSite', value: params.nextSite },
      ],
      inFilters: [
        { key: 'waybillNo', value: params.waybillNos },
      ],
      boundFilters: [
        ...bound,
        {
          "dimension": "unloadAggregateTime",
          "lowerValue": moment(params.startDate).add(-7, 'days').format('YYYY-MM-DD'),
          "upperValue": moment(params.endDate).format('YYYY-MM-DD'),
          "lowerEq": false,
          "upperEq": false
        },
      ],
    },
  }
}

/**
 * 库存非/优势产品
 */
export const departuresuPeriorityProductQuery = params => {
  return {
    unload: {
      simpleGranularity: 'all',
      dataSource: actualBase,
      dimensions: ['waybillNo', 'superiorityProduct'],
      startDate: moment(params.startDate).add(-7, 'days').format('YYYY-MM-DD HH:mm:ss'),
      endDate: params.endDate,
      aggregators: [CALCWEIGHT, PIECE],
      andFilters: [
        { key: 'scanType', value: '分拨卸车' },
        { key: 'isDestinationCenter', value: '否' },
        { key: 'scanSite', value: params.scanSite },
        { key: 'nextSite', value: params.nextSite },
      ],
    },
    load: {
      simpleGranularity: 'all',
      dataSource: actualBase,
      dimensions: ['waybillNo', 'superiorityProduct'],
      startDate: moment(params.startDate).add(-7, 'days').format('YYYY-MM-DD HH:mm:ss'),
      endDate: params.endDate,
      aggregators: [CALCWEIGHT, PIECE],
      andFilters: [
        { key: 'scanType', value: '分拨装车' },
        // { key: 'isDestinationCenter', value: '否' },
        { key: 'scanSite', value: params.scanSite },
        { key: 'planNextSite', value: params.nextSite },
      ],
      inFilters: [
        { key: 'waybillNo', value: params.waybillNos },
      ],
      boundFilters: [
        {
          "dimension": "unloadAggregateTime",
          "lowerValue": moment(params.startDate).add(-7, 'days').format('YYYY-MM-DD'),
          "upperValue": moment(params.endDate).format('YYYY-MM-DD'),
          "lowerEq": false,
          "upperEq": false
        }
      ],
    },
  }
}



/**
 * 预货量流向 主单分组 库存条件
 * @param {*} params
 * @returns
 */
export const PlanDepartureStockQuery = (params) => {
  const currentSystemTime = getCurrentSystemTime(params)
  const bound = []
  if (currentSystemTime) {
    bound.push(currentSystemTime)
  }
  return [
    {
      // 卸车
      simpleGranularity: 'all',
      dataSource: actualBase,
      dimensions: ['waybillNo', 'nextSite'],
      startDate: moment(params.startDate).add(-7, 'days').format('YYYY-MM-DD HH:mm:ss'),
      endDate: params.endDate,
      aggregators: [CALCWEIGHT],
      andFilters: [
        { key: 'scanType', value: '分拨卸车' },
        { key: 'isDestinationCenter', value: '否' },
        { key: 'scanSite', value: params.scanSite },
      ],
      inFilters: [
        { key: 'nextSite', value: params.siteNames },
      ],
      boundFilters: [
        ...bound
      ],
    },
    {
      // 装车
      simpleGranularity: 'all',
      dataSource: actualBase,
      dimensions: ['waybillNo', 'planNextSite'],
      startDate: moment(params.startDate).add(-7, 'days').format('YYYY-MM-DD HH:mm:ss'),
      endDate: params.endDate,
      aggregators: [CALCWEIGHT],
      andFilters: [
        { key: 'scanType', value: '分拨装车' },
        // { key: 'isDestinationCenter', value: '否' },
        { key: 'scanSite', value: params.scanSite },
      ],
      inFilters: [
        { key: 'waybillNo', value: params.waybillNos },
        { key: 'planNextSite', value: params.siteNames },
      ],
      boundFilters: [
        ...bound,
        {
          "dimension": "unloadAggregateTime",
          "lowerValue": moment(params.startDate).add(-7, 'days').format('YYYY-MM-DD'),
          "upperValue": moment(params.endDate).format('YYYY-MM-DD'),
          "lowerEq": false,
          "upperEq": false
        },
      ],
    },
    // #endregion
  ]
}
